import styled from "@emotion/styled";
import { Fonts } from "@snapchat/snap-design-system";

export const ListContainer = styled.div`
    padding-left: 20px;

    > ul > li {
        ${Fonts.Heading.H700}
        padding: 8px;
    }
`;
export const List = styled.ul`
    display: flex;
    list-style: none;
`;

export const ListItem = styled.li`
    display: flex;
    align-items: center;

    &:before {
        content: "";

        display: block;

        width: 12px;
        height: 12px;
        margin-right: 4px;

        background-color: ${(props) => props.color};
    }
`;
